import AppRoutes from "Routes";
import React from "react";

export default function App() {
  return <AppRoutes />;
}
